module.exports = __webpack_public_path__ + "img/qd-img-16.bb48d073.jpg";